import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const AccountSuspended = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  // Force logout on mount to clear tokens
  useEffect(() => {
    logout();
  }, [logout]);

  const handleExit = () => {
    // Navigate to login (which is the "Exit" for a web app)
    navigate('/login');
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>⛔</div>
        <h2 style={{color: '#c0392b', marginTop: 0}}>Account Suspended</h2>
        <p style={styles.text}>
          Your account has been suspended by the Admin Team.
        </p>
        <p style={styles.subText}>
          Please contact them for more information regarding this decision.
        </p>
        <button onClick={handleExit} style={styles.button}>
          Close Page & Exit App
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f4f6f8' },
  card: { width: '400px', padding: '40px', backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', textAlign: 'center' },
  icon: { fontSize: '4rem', marginBottom: '20px' },
  text: { fontSize: '1.1rem', color: '#2c3e50', fontWeight: 'bold', marginBottom: '10px' },
  subText: { color: '#7f8c8d', marginBottom: '30px', lineHeight: '1.5' },
  button: { padding: '12px 24px', backgroundColor: '#7f8c8d', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '1rem', fontWeight: 'bold', width: '100%' }
};

export default AccountSuspended;